// ============================================================
// ByOurConsent.com -- Returns Policy Page
// /returns
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';

const Section = ({ title, children }) => (
    <div style={{ marginBottom: '2rem' }}>
        <div style={{ fontSize: '11px', fontFamily: 'sans-serif', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8b6a3a', marginBottom: '8px' }}>
            {title}
        </div>
        <div style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.75 }}>
            {children}
        </div>
    </div>
);

const ReturnsPage = () => {
    return (
        <>
            <Helmet>
                <title>Returns Policy — By Our Consent</title>
            </Helmet>

            <Nav />

            <div style={{ background: '#1e2a3a', borderBottom: '2px solid #8b1a1a', padding: '2rem 1.5rem' }}>
                <div style={{ maxWidth: '660px', margin: '0 auto' }}>
                    <h1 style={{ fontSize: '34px', fontWeight: 600, color: '#e8dfc8', fontFamily: "'EB Garamond', Georgia, serif" }}>
                        Returns & exchanges
                    </h1>
                    <p style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#8a9aaa', marginTop: '8px' }}>
                        Because all items are printed on demand specifically for you, our returns
                        policy is limited to damaged or defective items.
                    </p>
                </div>
            </div>

            <div style={{ maxWidth: '660px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

                {/* We will replace */}
                <div style={{ background: '#e8f5e0', border: '0.5px solid #a8d0a0', borderLeft: '3px solid #3b6d11', borderRadius: '4px', padding: '1.25rem', marginBottom: '1.5rem' }}>
                    <div style={{ fontSize: '14px', fontWeight: 600, color: '#3b6d11', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '8px' }}>
                        ✓ We will replace or refund
                    </div>
                    <ul style={{ margin: '0 0 0 1.25rem', padding: 0, fontSize: '13px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.7 }}>
                        <li>Items damaged during shipping</li>
                        <li>Items with defective printing (fading, cracking, misalignment)</li>
                        <li>Wrong item sent (wrong design, wrong color)</li>
                        <li>Items that arrive in unwearable condition</li>
                    </ul>
                </div>

                {/* We cannot accept */}
                <div style={{ background: '#fdf0ee', border: '0.5px solid #d4a8a0', borderLeft: '3px solid #8b1a1a', borderRadius: '4px', padding: '1.25rem', marginBottom: '2rem' }}>
                    <div style={{ fontSize: '14px', fontWeight: 600, color: '#8b1a1a', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '8px' }}>
                        ✗ We cannot accept returns for
                    </div>
                    <ul style={{ margin: '0 0 0 1.25rem', padding: 0, fontSize: '13px', fontFamily: 'sans-serif', color: '#4a5060', lineHeight: 1.7 }}>
                        <li>Wrong size ordered — please check our size guide before ordering</li>
                        <li>Change of mind or buyer's remorse</li>
                        <li>Items that have been washed, worn, or altered</li>
                        <li>Slight color variations due to monitor display differences</li>
                    </ul>
                </div>

                <Section title="How to request a replacement">
                    <ol style={{ margin: '0 0 1rem 1.25rem', padding: 0, lineHeight: 1.8 }}>
                        <li>Email us at <a href="mailto:support@byourconsent.com" style={{ color: '#8b1a1a' }}>support@byourconsent.com</a></li>
                        <li>Include your order number</li>
                        <li>Attach a clear photo of the damaged or defective item</li>
                        <li>Describe the issue</li>
                    </ol>
                    We will review your request within 2 business days and arrange a replacement
                    or refund as appropriate. You do not need to return the damaged item.
                </Section>

                <Section title="Timeframe">
                    Replacement or refund requests must be submitted within{' '}
                    <strong>30 days</strong> of receiving your order.
                    After 30 days we are unable to process claims.
                </Section>

                <Section title="Refunds">
                    Approved refunds are issued to your original payment method within 5–10
                    business days depending on your bank or card issuer. Shipping costs are
                    non-refundable unless the return is due to our error.
                </Section>

                <Section title="Size guide">
                    To avoid sizing issues, please review the size guide on each product page
                    before ordering. If you are between sizes, we recommend sizing up.
                    We are not able to exchange items for a different size.
                </Section>

                <div style={{ padding: '1rem', background: '#ede8dc', border: '0.5px solid #c8beaa', borderRadius: '4px', fontSize: '13px', fontFamily: 'sans-serif', color: '#6a7080', lineHeight: 1.6 }}>
                    Have a question about an order?{' '}
                    <Link to="/contact" style={{ color: '#8b1a1a' }}>Contact us</Link>
                    {' '}and we'll make it right.
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ReturnsPage;
